<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Experts</div>
                </div>
                <div class="col-md-2 offset-md-2 text-right center">
                    <button type="submit" class="btn btn-primary btn-fill" @click="changeListOrder">Change List Order</button>
                </div>
                <div class="col-md-2 text-right center">
                    <button type="submit" class="btn btn-primary btn-fill" @click="addExpert">Add Expert</button>
                </div>
            </div>
            <div class="table-responsive text-center">
                <l-table class="table table-light table-bordered table-hover"
                         :columns="experts.columns" :data="experts.data">
                    <template slot="table-row" v-if="experts.data.length">
                        <tr v-for="(item, index) in experts.data" :key="index"  :class="{'inactive': !item.active}">
                            <td><img :src="item.small_image" alt="expert-image" class="table-thumbnail"></td>
                            <td>{{item.name}}</td>
                            <td>{{item.interestName}}</td>
                            <td>{{item.biography.substring(0,57).concat('...')}}</td>
                            <td>{{item.csvCorpNames}}</td>
                            <td>
                                <span class="badge badge-success" v-if="item.active"> Active </span>
                                <span class="badge badge-danger" v-else> Inactive </span>
                            </td>
                            <td>
                                <div class="btn-group" role="group">
                                    <button class="btn btn-secondary btn-sm" @click="viewExpert(item)" v-tooltip.top-center="experts.tooltips.view"><i class="fa fa-eye"></i></button>
                                    <button class="btn btn-info btn-sm" @click="editExpert(item)" v-tooltip.top-center="experts.tooltips.edit"><i class="fa fa-edit"></i></button>
                                    <button v-if="item.active" class="btn btn-danger btn-sm" @click="deleteExpert(item, true)" v-tooltip.top-center="experts.tooltips.delete"><i class="fa fa-toggle-off"></i></button>
                                    <button class="btn btn-success btn-sm" v-else @click="deleteExpert(item, false)" v-tooltip.top-center="experts.tooltips.delete"><i class="fa fa-toggle-on"></i></button>
                                </div>
                            </td>
                        </tr>
                    </template>
                </l-table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    const expertColumns = ['Image', 'Name', 'Interest', 'Biography', 'Corporations', 'Status', 'Operations'];
    export default {
        name: 'Experts',
        components: {
            LTable,
        },
        data() {
        return {
            experts: {
                tooltips: {
                    view: 'View Expert',
                    edit: 'Edit Expert',
                    delete: 'Inactivate Expert',
                    activate: 'Activate Expert'
                },
                columns: [...expertColumns],
        data: []
    }
    }
    },
    methods: {
        fetchExperts () {
            this.$store.dispatch('FETCH_EXPERTS')
                    .then((res) => {
                        this.experts.data = res;
                    })
                    .catch(err => {
                        console.log("API error : ", err);
                    })
                    , (err) => {
                console.log("err : ", err);
            }
        },
        viewExpert(expert){
            this.$router.push({ name: 'ViewExpert', params: { id: expert.expertId}})
        },
        editExpert(expert){
            this.$router.push({ name: 'EditExpert', params: { id: expert.expertId}})
        },
        addExpert(){
            this.$router.push({ name: 'CreateExpert'})
        },
        changeListOrder(){
            this.$router.push({ name: 'Experts Ordering'})
        },
        deleteExpert(expert, boolean){
            this.deleteExpertAPI({expert, boolean});
        },
        deleteExpertAPI(data){
            this.$store.dispatch('DELETE_SELECTED_EXPERT', {expertId: data.expert.expertId, isDelete: data.boolean})
                    .then((res) => {
                        console.log("DELETE_SELECTED_EXPERT API res : ", res);
                        this.fetchExperts();
                    })
                    .catch(err => {
                        console.log("DELETE_SELECTED_EXPERT API error : ", err);
                    })
        }
    },
    created() {
        this.fetchExperts();
    }
    }
</script>

<style>
    .btn-icon{
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Experts/Experts.vue